/**
 * Human caption for a 1-based inclusive page range: «Página 5» when it spans a single
 * page, «Páginas 3–4» otherwise. Shared by the split-children list, the segment chip
 * and the PDF viewer caption so the three always read the same.
 */
export function formatPageRange(startPage: number, endPage: number): string {
  if (startPage === endPage) {
    return `Página ${startPage}`;
  }
  return `Páginas ${startPage}–${endPage}`;
}
